import { useEffect, useState } from "react";
import api, { formatApiErrorDetail } from "@/lib/api";
import { isNativeApp, nativeDiagnostics } from "@/lib/native";
import { registerPush, pushStatus, onPushStatus } from "@/lib/push";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

export default function PushTest() {
  const [busy, setBusy] = useState(false);
  const [status, setStatus] = useState(pushStatus());
  const native = isNativeApp();
  useEffect(() => onPushStatus(setStatus), []);

  const send = async () => {
    setBusy(true);
    try {
      await registerPush();
      for (let i = 0; i < 16 && pushStatus() !== "registered" && /^(waiting|token received)/.test(pushStatus()); i++) {
        await new Promise((r) => setTimeout(r, 500));
      }
      const { data } = await api.post("/push/test");
      if (!data.devices) toast.error("No device registered yet. See the status line below.");
      else if (!data.sent) toast.error("Registered, but delivery failed. Check the APNs/FCM setup.");
      else toast.success("Test notification sent");
    } catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail)); }
    finally { setBusy(false); }
  };

  return (
    <div className="mt-4 border border-border bg-card p-4 rounded-sm" data-testid="push-test-card">
      <div className="label-xs mb-2">App push notifications</div>
      {native ? (
        <Button variant="outline" onClick={send} disabled={busy} data-testid="push-test">
          {busy ? "Sending..." : "Send test notification"}
        </Button>
      ) : (
        <div className="text-xs text-muted-foreground">Available in the MarketPilot365 mobile app.</div>
      )}
      <div className="mt-2 text-[10px] text-muted-foreground mono break-all">{nativeDiagnostics()} push={status}</div>
    </div>
  );
}
